import { useAppSelector } from 'shared/lib';

import { formBlockFFSelector } from 'entities/creditForm';
import { whiteLabelAffIdSelector } from 'entities/whiteLabels';

import {
  CreditCardFormStepHeaders,
  DefaultFormStepHeaders,
  PartnerFormStepHeadersConfig,
} from '../FormStepHeaders.config';

export const useFormStepHeadersConfig = () => {
  const partnerId = useAppSelector(whiteLabelAffIdSelector);
  const formBlockFF = useAppSelector(formBlockFFSelector);
  const defaultHeadersConfig = formBlockFF?.isCreditCardsForm ? CreditCardFormStepHeaders : DefaultFormStepHeaders;

  if (!partnerId) {
    return {
      headersConfig: defaultHeadersConfig,
      isAlwaysShowDescription: false,
    };
  }

  const WlFormStepHeadersConfig = PartnerFormStepHeadersConfig[partnerId] || null;

  if (!WlFormStepHeadersConfig) {
    return {
      headersConfig: defaultHeadersConfig,
      isAlwaysShowDescription: false,
    };
  }

  return {
    headersConfig: WlFormStepHeadersConfig,
    isAlwaysShowDescription: true,
  };
};
